// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Nav-module--navbar--qoXf0","logo":"Nav-module--logo--2tHOd","deviceIcon":"Nav-module--deviceIcon--2W7OC"};